import LanguageDetectorNames from "./constants/LanguageDetectorNames";
/**
 * The LanguageDetection module iterates over a stack of language detectors.
 */
var LanguageDetection = /** @class */ (function () {
    function LanguageDetection(detectors) {
        this.detectors = detectors;
    }
    /**
     * The language detection entry point.
     *
     * @return {array} The array of detected languages.
     */
    LanguageDetection.prototype.detect = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.ignoreForced, ignoreForced = _c === void 0 ? false : _c;
        var detector = this.getFirstSatisfiedDetector({ ignoreForced: ignoreForced });
        return {
            language: detector === null || detector === void 0 ? void 0 : detector.detect(),
            name: detector === null || detector === void 0 ? void 0 : detector.getName(),
        };
    };
    /**
     * Debug helper to show detectors by key/value pairs to validate which were satisfied.
     *
     * @return {object} The object with key/value pairs of detector and the validated value.
     */
    LanguageDetection.prototype.debug = function () {
        return this.detectors.reduce(function (accumulator, detector) {
            accumulator[detector.getName()] = detector.detect();
            return accumulator;
        }, {});
    };
    /**
     * Iterate the provided detectors returning the first detector that can find a valid language.
     *
     * @return {IDetector} The first detector which was able to find a language.
     */
    LanguageDetection.prototype.getFirstSatisfiedDetector = function (_a) {
        var ignoreForced = _a.ignoreForced;
        return this.detectors.find(function (detector) { return !!detector.detect() && (!ignoreForced || detector.getName() !== LanguageDetectorNames.ForcedLanguage); });
    };
    return LanguageDetection;
}());
export { LanguageDetection };
//# sourceMappingURL=LanguageDetection.js.map